// requestTimestampSlice.js

import { createSlice } from '@reduxjs/toolkit'

type InitialState = {
  lastRequestTime: Date
}
const initialState = {
  lastRequestTime: new Date()
} as InitialState

const requestTimeSlice = createSlice({
  name: 'requestTimeSlice',
  initialState: initialState, // Initial state should be null or a default timestamp
  reducers: {
    setRequestTimestamp: (state, { payload }) => {
      state.lastRequestTime = payload
    }
  }
})

export const { setRequestTimestamp } = requestTimeSlice.actions
export default requestTimeSlice.reducer
